import { Entity, Field } from 'typegraph';

import Tag from './Tag';

@Entity({one: "product", many: "products"})
export default class Product {

	@Field()
	public name: string;

	@Field()
	public subTitle: string;

	@Field()
	public description: string;

	@Field()
	public shortDescription: string;

	@Field()
	public iconURL: string;

	@Field()
	public smallIconURL: string;

	@Field({entity: Tag})
	public tags?: Tag[];

}



// WEBPACK FOOTER //
// ./src/panels/productDetails/entities/Product.ts